import React from 'react'
import PropTypes from 'prop-types'
import { QueryClient, QueryClientProvider } from 'react-query'

import { FormManagerContextProvider } from './components/forms/FormManager/Context/FormManagerContext'
import { UserContextProvider } from './contexts/UserContext'

// Create a client
const queryClient = new QueryClient()

const GlobalContextPrivers = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <UserContextProvider>
        <FormManagerContextProvider>{props.children}</FormManagerContextProvider>
      </UserContextProvider>
    </QueryClientProvider>
  )
}

GlobalContextPrivers.propTypes = {
  children: PropTypes.any,
}

export default GlobalContextPrivers
